import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import isEmpty from 'lodash/isEmpty';
import Cleave from 'cleave.js/react';
import { Input, MultiRadio, CheckboxList } from 'shared/components';
import { ValidationService } from 'shared/services';
import { errorStrings } from 'shared/validations';
import * as options from './experienceOptions';
import PlusIcon from 'assets/svgs/plusIcon.svg';
import './ExperienceQuestions.scss';

const onTypeRules = {
  totalTestingExp: ['numeric'],
};

const translate = (opts, t) => {
  opts.forEach((option) => {
    option.label = t(option.label);
  });
  return opts;
};

const setStandardizedTestList = (list) =>
  list
    .split(',')
    .map((element, idx) => {
      if (element.replaceAll(/\s/g, '').length > 0) {
        return {
          label: element,
          name: `standardizedTest${idx}`,
        };
      }
    })
    .filter(Boolean);

const setPriorExperience = (user, optionsList, t) => {
  optionsList.forEach((opt) => {
    opt.checked = user[opt.key];
    opt.label = t(opt.label);
  });
  return optionsList;
};

class ExperienceQuestions extends Component {
  constructor(props) {
    super(props);

    this.state = {
      errors: {},
      testsAdministration: props.user.taAdminCount,
      standardizedTest: '',
      standardizedTests: [],
      priorExperienceOptions: [],
      testsAdministrationOptions: translate(options.testsAdministrationOptions, props.t),
    };

    this.onPriorExperienceChange = this.onPriorExperienceChange.bind(this);
    this.onExperienceYearChange = this.onExperienceYearChange.bind(this);
    this.onActYearChange = this.onActYearChange.bind(this);
    this.onAdministrationChange = this.onAdministrationChange.bind(this);
    this.onTestChange = this.onTestChange.bind(this);
    this.addNewTest = this.addNewTest.bind(this);
  }

  componentDidMount() {
    const { user } = this.props;
    this.setState({
      previouslyAdministeredTests: user.previouslyAdministeredTests
        ? setStandardizedTestList(user.previouslyAdministeredTests)
        : [],
      priorExperienceOptions: user
        ? setPriorExperience(user, options.priorExperienceOptions, this.props.t)
        : [],
      testsAdministration: user.taAdminCount,
      totalTestingExp: user.totalTestingExp,
      firstActYear: user.firstActYear || '',
    });
  }

  onPriorExperienceChange(e) {
    const { priorExperienceOptions } = this.state;
    priorExperienceOptions.forEach((option) => {
      if (option.key === e.target.name) {
        option.checked = e.target.checked;
      }
      this.props.onChange(option.key, option.checked);
    });

    this.setState({
      priorExperienceOptions,
    });
  }

  onAdministrationChange(e) {
    this.setState({
      testsAdministration: Number(e.target.value),
    });

    this.props.onChange('taAdminCount', Number(e.target.value));
  }

  onTestChange(e) {
    const tests = this.state.previouslyAdministeredTests;

    const newTests = tests.map((test) => {
      if (test.name === e.target.name) {
        return {
          label: e.target.value,
          name: test.name,
        };
      }
      return test;
    });

    this.setState({
      previouslyAdministeredTests: newTests,
    });
    this.props.onChange(
      'previouslyAdministeredTests',
      newTests.map((element) => element.label)
    );
  }

  onExperienceYearChange(e) {
    const { value, name } = e.target;

    if (value.length > 2) {
      return;
    }
    const errors = ValidationService.validate({ [name]: value }, onTypeRules, errorStrings);
    this.setState({ errors });

    if (!isEmpty(errors)) {
      return;
    }
    this.setState({
      [e.target.name]: e.target.value,
    });

    this.props.onChange(e.target.name, value);
  }

  onActYearChange(e) {
    this.setState({
      [e.target.name]: e.target.rawValue,
    });
    this.props.onChange(e.target.name, e.target.value);
  }

  addNewTest() {
    const newTest = {
      label: '',
      name: `standardizedTest${this.state.previouslyAdministeredTests.length}`,
    };
    this.setState((prev) => ({
      ...prev,
      previouslyAdministeredTests: [...prev.previouslyAdministeredTests, newTest],
    }));
  }

  render() {
    return (
      <section className="demographic-questions">
        <form className="list-group list-group-flush">
          <div className="list-group-item">
            <CheckboxList
              checkboxes={this.state.priorExperienceOptions}
              onChange={this.onPriorExperienceChange}
              title={this.props.t('profile.pastExperience.priorExperienceQuestion')}
            />
          </div>
          <div className="list-group-item">
            <h6>{this.props.t('profile.pastExperience.standardizedTestLabel')}</h6>
            {this.state.previouslyAdministeredTests?.map((test) => (
              <Input
                type="text"
                key={test.name}
                name={test.name}
                value={test.label}
                onChange={this.onTestChange}
                label={this.props.t('profile.pastExperience.enterTest')}
              />
            ))}
            <div className="add-test-button">
              <PlusIcon />
              <div onClick={this.addNewTest} className="btn-link">
                {this.props.t('profile.pastExperience.addNewTest')}
              </div>
            </div>
          </div>
          <div className="list-group-item">
            <h6>{this.props.t('profile.pastExperience.testsAdministrationLabel')}</h6>
            <MultiRadio
              radioList={this.state.testsAdministrationOptions}
              checkedValue={this.state.testsAdministration}
              onChange={this.onAdministrationChange}
            />
          </div>
          <div className="list-group-item">
            <h6 aria-labelledby="totalTestingExp">
              {this.props.t('profile.pastExperience.experienceLabel')}
            </h6>
            <Input
              type="number"
              name="totalTestingExp"
              value={this.state.totalTestingExp}
              onChange={this.onExperienceYearChange}
            />
          </div>
          <div className="list-group-item">
            <h6>{this.props.t('profile.pastExperience.firstTestLabel')}</h6>
            <Cleave
              name="firstActYear"
              options={{
                date: true,
                datePattern: ['Y'],
              }}
              value={this.state.firstActYear}
              onChange={this.onActYearChange}
            />
          </div>
        </form>
      </section>
    );
  }
}

ExperienceQuestions.propTypes = {
  onChange: PropTypes.func.isRequired,
  user: PropTypes.shape({
    taAdminCount: PropTypes.number,
    previouslyAdministeredTests: PropTypes.string,
    totalTestingExp: PropTypes.number,
    firstActYear: PropTypes.string,
    expPrimaryAssessmentFlag: PropTypes.bool,
    expCollegeAssessmentFlag: PropTypes.bool,
    expGradAdmissionFlag: PropTypes.bool,
    expCertLicenseFlag: PropTypes.bool,
    expCbtFlag: PropTypes.bool,
  }).isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(ExperienceQuestions);
